export const GAME_USER_PROFILE_ACTION_PERSIST = "GAME_USER_PROFILE_PERSIST";
export const GAME_USER_PROFILE_ACTION_CLEAR = "GAME_USER_PROFILE_CLEAR";
